"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _reactLiveClock = _interopRequireDefault(require("react-live-clock"));
var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));
var _reactCalendarTimeline = _interopRequireWildcard(require("react-calendar-timeline"));
var _GetData = _interopRequireDefault(require("./GetData"));
require("react-calendar-timeline/lib/Timeline.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var App = exports["default"] = /*#__PURE__*/function (_Component) {
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _callSuper(this, App, [props]);
    var _getData = (0, _GetData["default"])(0, _this.props.openinghours, _this.props.lang),
      groups = _getData.groups,
      items = _getData.items,
      isOpen = _getData.isOpen,
      lowest = _getData.lowest,
      highest = _getData.highest,
      day_description = _getData.day_description,
      day_title = _getData.day_title,
      timeslot_description = _getData.timeslot_description,
      timeslot_title = _getData.timeslot_title,
      otherThanNull = _getData.otherThanNull;
    // convert every 2 groups out of 3 to nodes, leaving the first as the root
    var today = '';
    var newGroups = groups.map(function (group) {
      var isRoot = group.isRoot ? true : false;
      var parent = isRoot ? null : group.parent;
      if (Number(group.date) === new Date().getDate()) {
        today = group.parent;
      }
      return Object.assign({}, group, {
        root: isRoot,
        parent: parent
      });
    });
    _this.state = {
      groups: newGroups,
      items: items,
      openGroups: _defineProperty({}, today, true),
      idx: 0,
      activeTab: 0,
      isOpen: isOpen,
      lowest: lowest,
      highest: highest,
      new_lowest: '',
      new_highest: '',
      oh_description: '',
      day_description: day_description,
      timeslot_description: timeslot_description,
      timeslot_title: timeslot_title,
      day_title: day_title,
      zoomed: false,
      otherThanNull: otherThanNull
    };
    return _this;
  }
  _inherits(App, _Component);
  return _createClass(App, [{
    key: "toggleGroup",
    value: function toggleGroup(id) {
      var openGroups = this.state.openGroups;
      this.setState({
        openGroups: _defineProperty({
          openGroups: this.state
        }, id, !openGroups[id])
      });
    }
  }, {
    key: "switchTimetable",
    value: function switchTimetable(i, openinghours) {
      var _getData2 = (0, _GetData["default"])(i, openinghours, this.props.lang),
        groups = _getData2.groups,
        items = _getData2.items,
        isOpen = _getData2.isOpen,
        lowest = _getData2.lowest,
        highest = _getData2.highest,
        day_description = _getData2.day_description,
        day_title = _getData2.day_title,
        timeslot_description = _getData2.timeslot_description,
        timeslot_title = _getData2.timeslot_title,
        otherThanNull = _getData2.otherThanNull;
      var today = '';
      // convert every 2 groups out of 3 to nodes, leaving the first as the root
      var newGroups = groups.map(function (group) {
        var isRoot = group.isRoot ? true : false;
        var parent = isRoot ? null : group.parent;
        if (Number(group.date) === new Date().getDate()) {
          today = group.parent;
        }
        return Object.assign({}, group, {
          root: isRoot,
          parent: parent
        });
      });
      this.setState({
        groups: newGroups,
        items: items,
        openGroups: _defineProperty({}, today, true),
        idx: 0,
        activeTab: 0,
        isOpen: isOpen,
        lowest: lowest,
        highest: highest,
        day_description: day_description,
        timeslot_description: timeslot_description,
        timeslot_title: timeslot_title,
        otherThanNull: otherThanNull
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getDescriptions();
    }
  }, {
    key: "getDescriptions",
    value: function getDescriptions(activeTab) {
      var idx = this.state.idx;
      // Get the OH table descriptoin
      if (this.props.openinghours[activeTab ? activeTab : idx].message) {
        this.setState({
          oh_description: this.props.openinghours[activeTab ? activeTab : idx].message
        });
      } else {
        this.setState({
          oh_description: ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        groups = _this$state.groups,
        items = _this$state.items,
        openGroups = _this$state.openGroups,
        isOpen = _this$state.isOpen,
        activeTab = _this$state.activeTab,
        lowest = _this$state.lowest,
        highest = _this$state.highest,
        new_lowest = _this$state.new_lowest,
        new_highest = _this$state.new_highest,
        zoomed = _this$state.zoomed,
        otherThanNull = _this$state.otherThanNull;
      // hide (filter) the groups that are closed, for the rest, patch their "title" and add some callbacks or padding
      var newGroups = groups.filter(function (g) {
        return g.root || openGroups[g.parent];
      }).map(function (group) {
        return Object.assign({}, group, {
          title: group.root ? /*#__PURE__*/_react["default"].createElement("div", {
            className: "GroupTab ".concat(Number(group.date) === new Date().getDate() ? isOpen : '', " ").concat(openGroups[parseInt(group.id)] || Number(group.date) === new Date().getDate() ? 'selected' : ''),
            onClick: function onClick() {
              _this2.setState({
                day_title: group.title,
                timeslot_description: '',
                timeslot_title: ''
              });
              _this2.setState({
                timeslot_description: _this2.props.openinghours[activeTab].week[group.weekday].items.length > 0 && _this2.props.openinghours[activeTab].week[group.weekday].items[0].desc,
                timeslot_title: _this2.props.openinghours[activeTab].week[group.weekday].items.length > 0 && _this2.props.openinghours[activeTab].week[group.weekday].items[0].title
              });
              _this2.setState({
                day_description: _this2.props.openinghours[activeTab].week[group.weekday].message
              });
              _this2.toggleGroup(parseInt(group.id));
            }
          }, group.hasChildren && openGroups[parseInt(group.id)] ? /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
            name: "ArrowDown"
          }) : group.hasChildren && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
            name: "ArrowRight"
          }), /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              marginLeft: 'auto'
            }
          }, " ", group.title)) : /*#__PURE__*/_react["default"].createElement("div", {
            onClick: function onClick() {
              _this2.setState({
                timeslot_description: _this2.props.openinghours[activeTab].week[group.weekday].items[group.key].desc
              });
              _this2.setState({
                timeslot_title: _this2.props.openinghours[activeTab].week[group.weekday].items[group.key].title
              });
            },
            className: "GroupTab sub ".concat(group.isOpenSub),
            style: {
              paddingLeft: 20,
              cursor: 'pointer'
            }
          }, group.url ? /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noopener",
            href: group.url
          }, group.title) : /*#__PURE__*/_react["default"].createElement("span", null, group.title))
        });
      });

      // I use the itemRenderer to be able to use the onMouseDown event, when clicking on an item, it zooms in based on it's own timestamp. 
      var itemRenderer = function itemRenderer(_ref) {
        var item = _ref.item,
          itemContext = _ref.itemContext,
          getItemProps = _ref.getItemProps;
        return item.url ? /*#__PURE__*/_react["default"].createElement("a", _extends({}, getItemProps({
          style: item.itemProps.style,
          onMouseDown: function onMouseDown() {
            _this2.setState({
              new_lowest: item.start_time,
              new_highest: item.end_time,
              zoomed: !zoomed
            });
          }
        }), {
          target: "_blank",
          rel: "noopener",
          href: item.url
        }), itemContext.title, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, itemContext.title))) : /*#__PURE__*/_react["default"].createElement("div", getItemProps({
          style: item.itemProps.style,
          onMouseDown: function onMouseDown() {
            _this2.setState({
              new_lowest: item.start_time,
              new_highest: item.end_time,
              zoomed: !zoomed
            });
          }
        }), /*#__PURE__*/_react["default"].createElement("div", null, itemContext.title));
      };
      return this.props.openinghours.length > 0 && this.props.oh_received === true && this.props.openinghours[activeTab].is_24_7 ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "OH"
      }, /*#__PURE__*/_react["default"].createElement(TabMenu, {
        ohTabActive: activeTab,
        isOpen: isOpen,
        openinghours: this.props.openinghours,
        setTab: function setTab(i) {
          setTimeout(function () {
            _this2.switchTimetable(i, _this2.props.openinghours), _this2.switchTimetable(i, _this2.props.openinghours);
            _this2.setState({
              activeTab: i
            });
            _this2.getDescriptions(i);
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(isOpen, " OH_row always_open")
      }, (0, _idbReactTranslations["default"])('open247message', this.props.lang), " !")) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, this.props.openinghours.length > 0 && this.props.oh_received === true && otherThanNull ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "OH"
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TabMenu, {
        ohTabActive: activeTab
        // almost={almost}
        ,
        isOpen: isOpen,
        openinghours: this.props.openinghours
        // do this setupWeek function twice to make it work because props doesn't update after doing this one time (can search for a fix later)
        // setTab={(index) => { setTimeout(() => { setupWeek(index), setupWeek(index) }), setOhTabActive(index) }}
        ,
        setTab: function setTab(i) {
          setTimeout(function () {
            _this2.switchTimetable(i, _this2.props.openinghours), _this2.switchTimetable(i, _this2.props.openinghours);
            _this2.setState({
              activeTab: i
            });
            _this2.getDescriptions(i);
          });
        }
        // translate={(e) => translate(e)}
      }), !this.props.openinghours[activeTab].is_24_7 ? /*#__PURE__*/_react["default"].createElement(_reactCalendarTimeline["default"], {
        groups: newGroups,
        items: items
        // sidebarWidth={150}
        ,
        canMove: false,
        canResize: "right",
        canSelect: false,
        itemsSorted: true,
        itemTouchSendsClick: false,
        stackItems: true,
        itemHeightRatio: 0.75,
        sidebarWidth: 120,
        timeSteps: {
          second: 1,
          minute: 1,
          hour: 1,
          day: 1,
          month: 1,
          year: 1
        },
        showCursorLine: true,
        visibleTimeStart: zoomed && new_lowest ? new_lowest - 1800000 : lowest - 1800000,
        visibleTimeEnd: zoomed && new_highest ? new_highest + 1800000 : highest + 1800000,
        className: isOpen,
        itemRenderer: itemRenderer
      }, /*#__PURE__*/_react["default"].createElement(_reactCalendarTimeline.TimelineHeaders, {
        className: "",
        calendarHeaderClassName: "myHeader",
        style: {
          display: 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactCalendarTimeline.SidebarHeader, null, function (_ref2) {
        var getRootProps = _ref2.getRootProps;
        return /*#__PURE__*/_react["default"].createElement(_reactLiveClock["default"], {
          format: 'HH:mm:ss',
          ticking: true,
          timezone: 'CET'
        });
      }), /*#__PURE__*/_react["default"].createElement(_reactCalendarTimeline.CustomHeader, {
        height: 30,
        unit: "hour"
      }, function (_ref3) {
        var intervals = _ref3.headerContext.intervals,
          getRootProps = _ref3.getRootProps,
          getIntervalProps = _ref3.getIntervalProps;
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, getRootProps(), {
          id: "header"
        }), intervals.map(function (interval, index) {
          return /*#__PURE__*/_react["default"].createElement("div", _extends({
            // className="sticky"
            className: "sticky ".concat(index % 2 !== 0 ? 'inactive' : '', " "),
            style: {
              width: '50px'
            }
          }, getIntervalProps({
            interval: interval
          })), /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              minWidth: '200%',
              height: '100%',
              display: 'flex',
              justifyContent: 'space-around',
              padding: '5px 0'
            }
          }, /*#__PURE__*/_react["default"].createElement("span", null, Number(interval.startTime.format('HH')) < 9 && '0', Number(interval.startTime.format('HH')) + 1)));
        }));
      })), /*#__PURE__*/_react["default"].createElement(_reactCalendarTimeline.TodayMarker, null, function (_ref4) {
        var styles = _ref4.styles,
          date = _ref4.date,
          isOpen = _ref4.isOpen;
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: styles,
          className: "indicator"
        }, /*#__PURE__*/_react["default"].createElement("span", null));
      })) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(isOpen, " OH_row always_open")
      }, (0, _idbReactTranslations["default"])('open247message', this.props.lang), " !"))) : this.props.oh_received === 'loading' || !otherThanNull ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "timetable_message_wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "timetable_message_image"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../library/plenny.png'),
        alt: "plenny"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "timetable_message"
      }, (0, _idbReactTranslations["default"])('opening_hours_check', this.props.lang))) : '', (this.state.oh_description && this.state.oh_description.length > 0 || this.state.day_description && this.state.day_description.length > 0 || this.state.timeslot_title && this.state.timeslot_description && this.state.timeslot_description.length > 0) && typeof this.props.oh_received !== 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "activeDay"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "activeDay_icon_wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: "Info"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "activeDay_description top"
      }), this.state.oh_description && this.state.oh_description.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "activeDay_description"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "activeDay_title"
      }, this.props.openinghours[activeTab].title), /*#__PURE__*/_react["default"].createElement("span", {
        className: "activeDay_message"
      }, this.state.oh_description)), Array.isArray(this.state.day_description) && this.state.day_description.map(function (day_desc, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: i,
          className: "activeDay_description"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "activeDay_title"
        }, day_desc === null || day_desc === void 0 ? void 0 : day_desc.title), /*#__PURE__*/_react["default"].createElement("span", {
          className: "activeDay_message"
        }, day_desc === null || day_desc === void 0 ? void 0 : day_desc.message));
      }), this.state.timeslot_title && this.state.timeslot_description && /*#__PURE__*/_react["default"].createElement("div", {
        className: "activeDay_description"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "activeDay_title"
      }, this.state.timeslot_title), /*#__PURE__*/_react["default"].createElement("span", {
        className: "activeDay_message"
      }, this.state.timeslot_description))) : '');
    }
  }]);
}(_react.Component);
var TabMenu = function TabMenu(props) {
  // Creates arrow for the slick slider
  var Arrows = function Arrows(props) {
    var dir = props.dir === "next" ? "Right" : "Left";
    return /*#__PURE__*/_react["default"].createElement("div", {
      onClick: props.onClick,
      className: "arrows",
      style: _defineProperty({}, dir.toLowerCase(), "0px")
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Arrow".concat(dir)
    }));
  };

  // Sets the settings for the slick slider
  var settings = {
    arrows: true,
    dots: false,
    draggable: true,
    nextArrow: /*#__PURE__*/_react["default"].createElement(Arrows, {
      dir: "next"
    }),
    prevArrow: /*#__PURE__*/_react["default"].createElement(Arrows, {
      dir: "prev"
    }),
    slidesToScroll: 3,
    slidesToShow: 3,
    speed: 500,
    infinite: false
  };
  var tabRender = function tabRender(x) {
    return x;
  };
  if (props.openinghours.length > 2) {
    tabRender = function tabRender(x) {
      return /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], settings, x);
    };
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "OHheader"
  }, tabRender(props.openinghours.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ohTab ".concat(props.ohTabActive === index ? "active" : "", " ").concat(props.isOpen, " "),
      key: index,
      onClick: function onClick() {
        return props.setTab(index);
      }
    },
    // item.title.toLowerCase() === 'afspraak' ? props.translate('appointment') :
    // props.translate(item.title)
    item.title);
  })));
};